import Card from '@mui/material/Card'
import DataExportMasterData from '../../../pages/dataExport/DataExportMasterData'
import DataExportAuditTrail from '../../../pages/dataExport/DataExportAuditTrail'
import DataExportBusinessData from '../../../pages/dataExport/DataExportBusinessData'

const DataExportTabs = ({selectedTabIndex, allowedTabIndexes = [0, 1, 2]}) => {

    const tabSwitch = () => {
        if (!allowedTabIndexes.includes(selectedTabIndex)) {
            return
        }

        switch(selectedTabIndex){
            case 0:
                return <DataExportMasterData />
            case 1:
                return <DataExportBusinessData />
            case 2:
                return <DataExportAuditTrail />
            default:
                return
        }
    }

    return (
        <Card>
            {tabSwitch()}
        </Card>
    )
}

export default DataExportTabs
